import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Problems() {
  return (
    <section className="intro_section p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto ">
            <h2 style={{ color: "#000" }}>
              Main <span style={{ color: "#75CB4C" }}>Features</span>
            </h2>
            <p>
              We designed beach bandits mobile app to deliver a personalized
              experience to the users, from selecting their items to rent and
              packages to tracking their order. Beach Bandits boasts highly
              engaging user interface and super intuitive user journey featuring
              beautiful visuals.
            </p>
            <p>
              A trip to the beach will never be the same once you've used beach
              bandits.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto text-center offset-lg-1 "
          >
            <StaticImage
              src="../../../images/case-studies/beach-bandits/feature_img.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={571}
              height={578}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Problems;
